var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgManage = function SvgManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 4.59478L2.16667 11.6781V13.833H4.32149L11.4048 6.74963L9.25 4.59478ZM10.4285 3.41627L12.5833 5.57108L13.2441 4.91034C13.8391 4.31531 13.8391 3.35056 13.2441 2.75552C12.649 2.16048 11.6843 2.16048 11.0893 2.75552L10.4285 3.41627ZM1.33333 15.4996C0.8731 15.4996 0.5 15.1265 0.5 14.6663V11.333C0.5 11.1119 0.5878 10.9 0.744075 10.7437L9.91075 1.57701C11.1567 0.331101 13.1767 0.331101 14.4226 1.57701C15.6685 2.82292 15.6685 4.84294 14.4226 6.08885L5.25593 15.2555C5.09964 15.4118 4.88768 15.4996 4.66667 15.4996H1.33333Z",
    fill: "#5542F6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manage.08204ea5.svg";
export { ForwardRef as ReactComponent };